import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import logo from '../../assets/images/logo.png';
import {
  LayoutDashboard,
  Newspaper,
  FileEdit,
  CalendarCheck,
  Image,
  ClipboardCheck,
  UserCircle,
  LogOut,
  X,
} from 'lucide-react';

const navItems = [
  { to: '/reporter/dashboard', icon: LayoutDashboard, labelEn: 'Dashboard', labelNe: 'ड्यासबोर्ड' },
  { to: '/reporter/articles', icon: Newspaper, labelEn: 'My Articles', labelNe: 'मेरा लेखहरू' },
  { to: '/reporter/create-article', icon: FileEdit, labelEn: 'Create Article', labelNe: 'लेख लेख्नुहोस्' },
  { to: '/reporter/events', icon: CalendarCheck, labelEn: 'Event Coverage', labelNe: 'कार्यक्रम रिपोर्ट' },
  { to: '/reporter/media', icon: Image, labelEn: 'Media Uploads', labelNe: 'मिडिया अपलोड' },
  { to: '/reporter/dashboard', icon: ClipboardCheck, labelEn: 'Review Status', labelNe: 'समीक्षा स्थिति' },
  { to: '/reporter/profile', icon: UserCircle, labelEn: 'Profile', labelNe: 'प्रोफाइल' },
];

const ReporterSidebar = ({ open, onClose, language }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const sidebarContent = (
    <div className="flex h-full flex-col bg-white">
      <div className="flex items-center justify-between border-b border-char-100 px-6 py-4">
        <div className="flex items-center gap-3">
          <img src={logo} alt="Bholiko Itahari" className="h-9 w-9 rounded-xl object-cover" />
          <div>
            <p className="text-sm font-extrabold text-char-900 leading-tight">
              Bholiko Itahari
            </p>
            <p className="text-[10px] font-semibold uppercase tracking-wider text-primary">
              Reporter Panel
            </p>
          </div>
        </div>
        <button onClick={onClose} className="rounded-lg p-1.5 text-char-400 hover:bg-char-50 lg:hidden">
          <X size={20} />
        </button>
      </div>

      <nav className="flex-1 overflow-y-auto px-3 py-4">
        <ul className="space-y-1">
          {navItems.map(({ to, icon: Icon, labelEn, labelNe }) => (
            <li key={to}>
              <NavLink
                to={to}
                onClick={onClose}
                className={({ isActive }) =>
                  `flex items-center gap-3 rounded-xl px-4 py-2.5 text-sm font-semibold transition-all duration-200 ${
                    isActive
                      ? 'bg-primary-100 text-primary shadow-sm'
                      : 'text-char-600 hover:bg-char-50 hover:text-char-900'
                  }`
                }
              >
                <Icon size={18} />
                <span>{language === 'ne' ? labelNe : labelEn}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      <div className="border-t border-char-100 px-3 py-4">
        <button
          onClick={handleLogout}
          className="flex w-full items-center gap-3 rounded-xl px-4 py-2.5 text-sm font-semibold text-char-600 transition-all duration-200 hover:bg-error-50 hover:text-error"
        >
          <LogOut size={18} />
          <span>{language === 'ne' ? 'लगआउट' : 'Logout'}</span>
        </button>
      </div>
    </div>
  );

  return (
    <>
      {/* Desktop sidebar */}
      <aside className="fixed left-0 top-0 z-30 hidden h-screen w-64 border-r border-char-100 shadow-sm lg:block">
        {sidebarContent}
      </aside>

      {/* Mobile drawer overlay */}
      {open && (
        <div className="fixed inset-0 z-40 lg:hidden">
          <div className="absolute inset-0 bg-char-900/40 backdrop-blur-sm" onClick={onClose} />
          <aside className="relative h-screen w-72 shadow-2xl animate-in slide-in-from-left">
            {sidebarContent}
          </aside>
        </div>
      )}
    </>
  );
};

export default ReporterSidebar;
